/**
 * Words for Superadmin → Employment law. Pure — `node src/lib/employmentLaw.checks.mjs`.
 *
 * ⚠️ NO LAW IN HERE EITHER. Every figure arrives from GET /superadmin/employment-law,
 * which reads `services/jurisdictions.py`. This file only turns minutes into words and
 * decides whether a "checked" date has gone stale.
 */

/** 360 -> "6 hours", 270 -> "4.5 hours", 20 -> "20 minutes", 90 -> "1.5 hours". */
export function minutesInWords(n) {
  const m = Number(n);
  if (!Number.isFinite(m)) return '';
  if (m < 60) return `${m} ${m === 1 ? 'minute' : 'minutes'}`;
  const h = Math.round((m / 60) * 10) / 10;
  return `${h} ${h === 1 ? 'hour' : 'hours'}`;
}

/** 28 -> "28", 5.6 -> "5.6", 33.60000001 -> "33.6". */
export const num = (n) => String(Math.round(Number(n) * 10) / 10);

/**
 * True when the figures were last checked more than a year before `today` (or never).
 * A year is the promise on the screen: "checked within the last year, or amber".
 */
export function isStale(checkedOn, today = new Date()) {
  if (!checkedOn) return true;
  const checked = new Date(`${checkedOn}T00:00:00`);
  if (Number.isNaN(checked.getTime())) return true;
  const yearLater = new Date(checked);
  yearLater.setFullYear(yearLater.getFullYear() + 1);
  return today > yearLater;
}
